import { find, isEqual, pick } from 'lodash-es';
import * as status from '../constants/requestStatus';
export function isDownloading(state, _a) {
    var screenID = _a.screenID, elementID = _a.elementID, assetType = _a.assetType;
    var request = getRequestStatus(state, { screenID: screenID, elementID: elementID, assetType: assetType });
    if (!request) {
        return false;
    }
    return request.status === status.PENDING;
}
export function hasDownloaded(state, _a) {
    var screenID = _a.screenID, elementID = _a.elementID, assetType = _a.assetType;
    var request = getRequestStatus(state, { screenID: screenID, elementID: elementID, assetType: assetType });
    if (!request) {
        return false;
    }
    return request.status === status.SUCCESS;
}
function getRequestStatus(state, _a) {
    var screenID = _a.screenID, elementID = _a.elementID, assetType = _a.assetType;
    return find(state.downloadAssets, function (o) {
        return isEqual(pick(o, ['screenID', 'elementID', 'assetType']), {
            screenID: screenID,
            elementID: elementID,
            assetType: assetType,
        });
    });
}
